/**
 * Shopify inbound presenter.
 */
import type { InboundProviderPresenter } from '@/lib/integrations/inbound/types'

import {
  SHOPIFY_EVENT_CATEGORIES,
  SHOPIFY_EVENT_METADATA,
} from './supported-events'

export const SHOPIFY_SIGNING_SECRET_MIN_LENGTH = 16

export const shopifyInboundPresenter: InboundProviderPresenter = {
  providerId: 'shopify',
  displayName: 'Shopify',
  categories: SHOPIFY_EVENT_CATEGORIES,
  events: SHOPIFY_EVENT_METADATA,
  eventSetupNote:
    'Shopify sends Brew an event only if that specific topic has its own webhook configured in Shopify Admin. Create a separate webhook for each event you plan to use, choosing the name shown after "In Shopify", then click "Send test" on each webhook to verify it.',
  defaultTriggerLoop: true,
  triggerEventId({ orgId, brandId, eventType }) {
    return `shopify:${orgId}:${brandId}:${eventType}`
  },
}
